module.exports = __webpack_public_path__ + "img/pic_1_2.f400882e.jpg";